module.exports = __webpack_public_path__ + "img/140.07ab07ba.jpg";